'use strict';

import Header from './Header';
import PrivateLayout from './PrivateLayout';
import { useAuth } from '../contexts/AuthContext';

/**
 * Renders the page chrome that fits the viewer:
 *   - authenticated → <PrivateLayout> (sidebar nav + topbar)
 *   - anonymous     → bare <Header /> over the page content
 *
 * Use for pages that are reachable both from the logged-in dashboard AND from
 * public links (land detail, auction detail, recipes…). Pages that are gated
 * behind <RouteProtegee> can use <PrivateLayout> directly.
 */
export default function PageShell({ children }) {
  const { estConnecte } = useAuth();
  if (estConnecte) {
    return <PrivateLayout>{children}</PrivateLayout>;
  }
  return (
    <>
      <Header />
      {children}
    </>
  );
}
